import React, { useState, useEffect } from "react"
import axiosJWT from '../../JwtToken'
import Pagination from '../../pages/paginations'
import parse from 'html-react-parser'

function View() {
    // 1. States Utama
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [msg, setMsg] = useState("")
    const [pesan, setPesan] = useState(false)
    const [deleteID, setDeleteID] = useState(null)

    // 2. State Pagination & Filter
    const [page, setPage] = useState(1)
    const [jml, setJml] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [search, setSearch] = useState("")

    // 3. State Modal
    const [showModalFile, setShowModalFile] = useState(false)
    const [fileUrl, setFileUrl] = useState("")

    const [showModalRespon, setShowModalRespon] = useState(false)
    const [selectedPenawaran, setSelectedPenawaran] = useState(null)
    const [formRespon, setFormRespon] = useState({ catatan: "", status: "Diterima" })

    const getData = async () => {
        setLoading(true)
        try {
            const response = await axiosJWT.get("/api/penawaran-usaha", {
                params: { key: search, jml, page }
            })
            setData(response.data.data || [])
            setTotalData(response.data.totalData || 0)
        } catch (err) {
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                ? err.response.data.msg
                : 'Gagal memuat data!'
            handleMessage(errorMsg)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getData()
    }, [page, jml, search])

    const handleSaveRespon = async () => {
        try {
            await axiosJWT.put(`/api/penawaran-usaha`, {
                id: selectedPenawaran._id,
                catatan: formRespon.catatan,
                status: formRespon.status
            })
            handleMessage("Respon berhasil dikirim!")
            setShowModalRespon(false)
            getData()
        } catch (err) {
            handleMessage("Gagal menyimpan respon")
        }
    }

    const handleMessage = (text) => {
        setMsg(text)
        setPesan(true)
        setTimeout(() => setPesan(false), 2000)
    }

    const triggerHapus = (id) => {
        setDeleteID(id)
    }

    const handleDelete = async () => {
        if (!deleteID) return

        try {
            const res = await axiosJWT.delete(`/api/penawaran-usaha/${deleteID}`)
            setDeleteID(null)
            handleMessage(res.data.msg)
            getData() // Refresh table
        } catch (err) {
            setDeleteID(null)
            handleMessage("Gagal menghapus data")
        }
    }

    return (<>
        <div className="container">
            <div className="card animated fadeInUp animation-delay-7 br-2 mb-6">
                <div className="card-body p-5">
                    {/* FILTER SECTION */}
                    <div className="form-group row">
                        <div className="col-md-2">
                            <select className="form-control" value={jml} onChange={(e) => { setJml(e.target.value); setPage(1); }}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </select>
                        </div>
                        <div className="col-md-10">
                            <input type="text" className="form-control" placeholder="Cari penawaran..." onChange={(e) => { setSearch(e.target.value); setPage(1); }} />
                        </div>
                    </div>

                    {/* TABLE */}
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr className="purple">
                                    <th>No</th>
                                    <th>PIC Info</th>
                                    <th>Kegiatan</th>
                                    <th>Deskripsi</th>
                                    <th>Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((kegiatan, i) => (
                                    // Lo mapping dulu per Kegiatan Usaha
                                    <React.Fragment key={kegiatan._id}>
                                        {kegiatan.listPenawaran.map((penawaran, j) => (
                                            <tr key={penawaran._id}>
                                                <td width={'5%'}>{i + 1}.{j + 1}</td>
                                                <td width={'15%'}>
                                                    {penawaran.namaPIC} <br />
                                                    <small>{penawaran.noHP}</small> <br />
                                                    <small>NPWP: {penawaran.npwp}</small>
                                                </td>
                                                <td width={'25%'}>
                                                    <strong>{kegiatan.name}</strong><br />
                                                    <button onClick={() => { setFileUrl(penawaran.urlPath); setShowModalFile(true); }}
                                                        className="btn btn-xs btn-default btn-raised br-2">
                                                        <i className="fa fa-file-text text-primary"></i> Proposal
                                                    </button>
                                                </td>
                                                <td width={'44%'}>{parse(penawaran.deskripsi || "")}</td>
                                                <td width={'11%'}>
                                                    <button onClick={() => {
                                                        setSelectedPenawaran(penawaran);
                                                        setShowModalRespon(true);
                                                    }} title="Berikan Respon" className="btn btn-xs btn-raised btn-info br-2">
                                                        <i className="fa fa-comment no-m"></i>
                                                    </button>

                                                    <button onClick={() => triggerHapus(penawaran._id)} title="Hapus Penawaran" className="btn btn-xs btn-raised btn-danger br-2 ml-1">
                                                        <i className="fa fa-remove no-m"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* PAGINATION */}
                    <Pagination
                        currentPage={page}
                        totalCount={totalData}
                        pageSize={jml}
                        onPageChange={setPage}
                    />
                </div>
            </div>
        </div>

        {showModalFile && (
            <div className="modal-backdrop fade in" style={{ zIndex: 1040 }}></div>
        )}

        {/* DIALOG PRATINJAU DOKUMEN (MODAL PREVIEW) */}
        {showModalFile && (
            <div className="modal-open">
                <div className="modal modal-primary show" style={{ display: "block", zIndex: 1060 }}>
                    <div className="modal-dialog">
                        <div className="modal-content br-0">
                            <div className="modal-header bg-purple">
                                <button type="button" className="close ml-1" onClick={() => setShowModalFile(false)} style={{ opacity: 1 }}><i className="fa fa-remove"></i></button>
                                <h4 className="modal-title"><i className="fa fa-certificate"></i> File Proposal</h4>
                            </div>
                            <div className="modal-body p-0" style={{ height: '50vh', overflow: 'hidden', backgroundColor: '#525659' }}>
                                {fileUrl ? (
                                    <iframe src={`${fileUrl}#toolbar=1&navpanes=0&scrollbar=1`} width="100%" height="100%" frameBorder="0" title="File TJSL"></iframe>
                                ) : (
                                    <div className="p-5 text-center text-white">Memuat dokumen...</div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-default btn-raised br-2" onClick={() => setShowModalFile(false)}>Tutup</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" style={{ zIndex: 1055 }}></div>
            </div>
        )}

        {showModalRespon && (
            <div className="modal-open">
                <div className="modal modal-primary show" style={{ display: "block", zIndex: 1060 }}>
                    <div className="modal-dialog">
                        <div className="modal-content br-0">
                            <div className="modal-header bg-purple">
                                <h4 className="modal-title">Tanggapi Penawaran: {selectedPenawaran.namaPIC}</h4>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Status</label>
                                    <select className="form-control" onChange={(e) => setFormRespon({ ...formRespon, status: e.target.value })}>
                                        <option value="Diterima">Diterima</option>
                                        <option value="Ditolak">Ditolak</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Catatan/Instruksi</label>
                                    <textarea className="form-control" rows="4"
                                        onChange={(e) => setFormRespon({ ...formRespon, catatan: e.target.value })}
                                        placeholder="Masukkan catatan untuk pelaku usaha..." />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-raised btn-default" onClick={() => setShowModalRespon(false)}>Batal</button>
                                <button className="btn btn-raised btn-primary" onClick={handleSaveRespon}>Simpan & Kirim WA</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" style={{ zIndex: 1055 }}></div>
            </div>
        )}

        {deleteID && (
            <div className="modal-open">
                <div style={{ display: 'block' }} className="modal modal-danger show" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog center">
                        <div className="modal-content modal-sm">
                            <div className="modal-header header-modal-danger p-1" style={{ backgroundColor: '#e51c23' }}>
                                <h4 className="modal-title text-center no-p font-bold" style={{ color: '#fff' }}>KONFIRMASI</h4>
                            </div>
                            <div className="modal-body text-center" style={{ padding: '20px 10px' }}>
                                <h4 className="font-bold" style={{ fontSize: '14px', margin: 0 }}>
                                    Apakah Anda yakin ingin menghapus data penawaran ini?
                                </h4>
                                <p className="text-danger" style={{ fontSize: '11px', marginTop: '5px', marginBottom: 0 }}>
                                    *Berkas fisik File di server juga akan dihapus permanen.
                                </p>
                            </div>
                            <div className="modal-footer text-center" style={{ padding: '10px', display: 'flex', justifyContent: 'center', gap: '10px', borderTop: '1px solid #eee' }}>
                                <button onClick={handleDelete} type="button" className="btn btn-raised btn-danger br-2" style={{ margin: 0, padding: '6px 15px' }}>
                                    <i className="fa fa-check"></i> Ya, Hapus
                                </button>
                                <button onClick={() => setDeleteID(null)} type="button" className="btn btn-raised btn-default br-2" style={{ margin: 0, padding: '6px 15px', backgroundColor: '#e0e0e0' }}>
                                    Batal
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </div>
        )}

        <div className={pesan ? "modal-open" : ""}>
            <div style={{ display: pesan ? 'block' : 'none' }} className={pesan ? "modal modal-primary show" : "modal modal-primary"} id="myData" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog center">
                    <div className="modal-content modal-sm">
                        <div className="modal-header header-modal-primary p-1">
                            <h4 className="modal-title text-center no-p font-bold" id="myModalLabel">
                                PESAN
                            </h4>
                        </div>
                        <div className="modal-body text-center">
                            <h4 className="font-bold">{msg.toUpperCase()}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {pesan ? <div className="modal-backdrop fade in"></div> : ""}
    </>)
}

export default View